<script lang="ts">
	import * as Table from "#lib/web-ui/ui/table/index.js";
	import { Section, SectionHeader, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import { RichText, type RichTextSegment } from "./glossary";

	interface Row {
		label: string;
		cells: RichTextSegment[][];
	}

	interface Props {
		title: string;
		subtitle: string;
		rowHeaderLabel: string;
		columns: string[];
		rows: Row[];
		note: string;
		theme?: SectionTheme;
		id?: string;
	}

	let {
		title,
		subtitle,
		rowHeaderLabel,
		columns,
		rows,
		note,
		theme = "light",
		id
	}: Props = $props();
</script>

<Section {theme} {id} data-testid="associate-comparison">
	<SectionHeader {title} {subtitle} align="left" class="mb-8" />

	<div>
		<Table.Root class="text-xs md:text-sm">
			<Table.Caption class="sr-only">{title}</Table.Caption>
			<Table.Header>
				<Table.Row>
					<Table.Head class="w-1/4 px-2">
						<span class="sr-only">{rowHeaderLabel}</span>
					</Table.Head>
					{#each columns as column (column)}
						<Table.Head
							class="text-foreground w-1/4 px-2 font-semibold whitespace-normal"
						>
							{column}
						</Table.Head>
					{/each}
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{#each rows as row (row.label)}
					<Table.Row>
						<Table.Cell
							class="text-foreground px-2 align-top font-semibold whitespace-normal"
						>
							{row.label}
						</Table.Cell>
						{#each row.cells as cell, index (index)}
							<Table.Cell
								class="text-muted-foreground px-2 align-top whitespace-normal"
							>
								<RichText segments={cell} />
							</Table.Cell>
						{/each}
					</Table.Row>
				{/each}
			</Table.Body>
		</Table.Root>
		<p class="text-foreground mt-8 text-base font-medium">{note}</p>
	</div>
</Section>
